
import { motion } from "framer-motion";

export function FeatureGrid() {

    return (
        <section className="py-16 px-6">
            <div className="container mx-auto max-w-6xl">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

                </div>
            </div>
        </section>
    );
}


export function Footer() {
    return (
        <footer className="pt-12 sm:pt-16 md:pt-20 pb-8 sm:pb-10 px-4 sm:px-6 border-t border-white/10 text-gray-400 text-sm">
            <div className="container mx-auto max-w-6xl">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 mb-8 sm:mb-12">
                    <div>
                        <a href="#" className="text-xl sm:text-2xl font-bold tracking-tighter text-white block mb-3 sm:mb-4" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                            TBOX
                        </a>
                        <p className="text-sm sm:text-base max-w-xs">
                            TSE-Komplettlösung für Taxiunternehmen. Sofort lieferbar, ohne Warteliste.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-bold text-white mb-3 sm:mb-4 text-base sm:text-lg">Kontakt</h4>
                        <ul className="space-y-2 text-sm sm:text-base">
                            <li>
                                <a href="tel:+4930959982020" className="hover:text-white transition-colors">030 959982020</a>
                                <span className="text-gray-500 text-xs block mt-1">Mo-Fr: 10-15 Uhr</span>
                            </li>
                            <li><a href="mailto:support@taxifusion.de?subject=Terminvereinbarung%20TBOX&body=Guten%20Tag%2C%0A%0Aich%20interessiere%20mich%20f%C3%BCr%20die%20TBOX%20Komplettl%C3%B6sung.%0A%0AAnzahl%20ben%C3%B6tigter%20TBOXen%3A%20%5BBitte%20angeben%5D%0A%0AR%C3%BCckrufnummer%3A%20%5BBitte%20angeben%5D%0A%0AHinweise%2FAnmerkungen%3A%0A%5BBitte%20angeben%5D%0A%0AMit%20freundlichen%20Gr%C3%BC%C3%9Fen" className="hover:text-white transition-colors">support@taxifusion.de</a></li>
                            <li><a href="https://taxifusion.de" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">TaxiFusion Website</a></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-white/10 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs sm:text-sm">
                    <p>&copy; 2026 TBOX. Alle Rechte vorbehalten.</p>
                    <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                        <a href="#impressum" className="hover:text-white transition-colors">Impressum</a>
                    </div>
                </div>
            </div>
        </footer>
    )
}
